import {safeParse} from '.'

const UC_SETTINGS_KEY = 'ucData'

type ServiceConsentModel = {
  name: string
  consent: boolean
}
interface UCSettings {
  consent: {
    services: Record<string, ServiceConsentModel>
  }
}

export type UserledTracker = {
  page: (name?: string) => void
}

export const getServiceConsent = (serviceId: string): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  const ucSettings: UCSettings | null = safeParse(localStorage.getItem(UC_SETTINGS_KEY))
  const service = ucSettings?.consent?.services[serviceId]

  return service?.consent ?? false
}
